<template>

	<span>

		<div class="modal smaller" v-if="!straightToPayment||straightToPaymentLoading">

			<div class="modal-wrap">

				<div class="modal-inner">

					<div v-if="!straightToPayment">

						<h2 class="modal-title"><em v-html="modalTitleTop" /><br>{{modalTitleBottom}}<span class="close" @click="close">X</span></h2>

						<div class="modal-inner-scroll" v-if="loaded">

							<p class="em" v-html="modalTextEm" />

							<p>Just click the button below to buy a one-off bolt on of <br><em>{{paymentInfo.quantity}} Analysis Credits for ${{paymentInfo.amount}}</em> (valid for 1 month).</p>

							<div class="btn-wrap">

								<span class="flip-colours large-button get" @click="getMore">Get additional Analysis Credits</span>
								<br>
								<span class="large-button mini" @click="showHow">How do Analysis Credits work?</span>

							</div>

							<span class="mag"></span>

							<Loading v-if="loadingText!==''" position="inner" :text="loadingText" />

						</div>

					</div>

					<div v-if="straightToPayment&&straightToPaymentLoading" class="completing-purchase">

						<Loading v-if="loadingText!==''" position="inner" :text="loadingText" />

					</div>

				</div>

			</div>

		</div>

		<Payment 
			v-if="paymentInfo.show" 
			:paymentInfo="paymentInfo.info" 
			:title="paymentInfo.title"
			:frequency="paymentInfo.frequency"
			:amount="paymentInfo.amount"
			service="analysis_credits"
			@close-payment="closePayment"
			:requireAddress="true"
			:openingText="paymentInfo.openingText"
			stripeTextColour="#394559"
		/>

	</span>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ApiService from './../../services/api.service'
import Payment from './../Payment.vue'
import general from './../../utils/general'
import Loading from './../Loading.vue'
export default {
	name: 'AnalysisCreditsOops',
	components: {
		Payment,
		Loading
	},
	props: {
		straightToPayment: {
			type: Boolean,
			default: false
		}
	},
	data() {

		return {
			credits: '',
			showPaymentWindow: false,
			lastWebhookUpdate: {},
			lastWebhookUpdateCheck: {},
			loadUserCount: 0,
			theLoadingText: '',
			straightToPaymentLoading: false
		}

	},
	computed: { 
		
		...mapState('general',['analysisCredits','reloadAnalysisCredits','products']),

		modalTitleTop () {

			if ( this.analysisCredits > 10 ) return "Buy More";

			if ( this.analysisCredits > 0 ) return "Close Call!";

			return 'Oops!';

		},

		modalTitleBottom () {

			if ( this.analysisCredits > 10 ) return "Get yourself some more Analysis Credits";

			if ( this.analysisCredits > 0 ) return "You've almost run out of Analysis Credits";

			return "It seems you've run out of Analysis Credits";

		},

		modalTextEm () {

			if ( this.analysisCredits > 10 ) return "Just a few clicks away...";

			return "Don't worry, it's easy to add more.";

		},

		loadingText () {

			return !this.loaded ? 'Loading...' : this.theLoadingText;

		},

		paymentInfo () {

			if ( !this.loaded ) return {};

			let r = {
				show: this.showPaymentWindow,
				info: {
					price: this.productInfo.price._id,
					product: this.productInfo._id
				},
				amount: this.productInfo.price.amount / 100,
				quantity: this.productInfo.analysis_credits,
				frequency: this.productInfo.price.frequency,
				title: this.productInfo.label,
				openingText: "Your Analysis Credits will be valid for 1 month"
			};

			return r;

		},
		productInfo () {

			let p = this.products.analysis_credits[0],
				r = { price: p.prices[0] };

			r.label = p.analysis_credits + ' Analysis Credits';
			r._id = p._id;
			r.analysis_credits = p.analysis_credits;

			return r;

		},
		loaded () {

			return !!this.products.analysis_credits;

		}

    },
	mounted() {

		if ( this.straightToPayment ) this.showPaymentWindow = true;

	},

	methods: {

		...mapMutations('general',['updateLoadingText','updateVar']),

		showHow () {

			this.updateVar( {varName:'showAnalysisCreditsHow', info:true} ); 

		},

		loadUser ( callback ) {
			
			ApiService.get( 'users', null, 'AnalysisCreditsOops' )
			.then( function( info ) {

				this.lastWebhookUpdate = typeof info.data.lastWebhookUpdate !== 'undefined' ? info.data.lastWebhookUpdate : {};

				if ( typeof callback === 'function' ) {

					callback();

				}

				this.checkForUpdates ();

				this.theLoadingText = 'Completing your purchase...';

			}.bind(this))
			.catch( function(err) {
				console.log(err);
			});

		},

		registerForUpdates ( events, callback ) {

			this.loadUserCount = 0;

			this.loadUser ( function () {

				events.forEach ( function (ev) {

					let ev2 = ev.split('.').join('-');

					this.lastWebhookUpdateCheck[ev2] = typeof this.lastWebhookUpdate[ev2] !== 'undefined' ? this.lastWebhookUpdate[ev2] : null;

				}.bind(this));
				
				if ( typeof callback === 'function' ) callback();

			}.bind(this));

		},

		checkForUpdates () {

			if ( Object.keys( this.lastWebhookUpdateCheck ).length > 0 ) {

				let updated = false;

				Object.keys( this.lastWebhookUpdateCheck ).forEach ( function (ev) {

					let ev2 = ev.split('.').join('-');

					if ( typeof this.lastWebhookUpdate[ev2] !== 'undefined' && this.lastWebhookUpdate[ev2] !== this.lastWebhookUpdateCheck[ev2] ) {

						updated = true;

					}

				}.bind(this));
				
				if ( updated ) {

					this.lastWebhookUpdateCheck = {};
					this.theLoadingText = '';
					this.updateVar( { varName: 'reloadAnalysisCredits', info: true } );
					this.close();
					this.$snotify.success("Your payment was successfull and the Analysis Credits have been added to your account.", "Payment");

				}
				else {

					if ( this.loadUserCount < 15 ) {
						
						setTimeout(function () {

							++this.loadUserCount;
							this.loadUser();

						}.bind(this), 2000);

					}
					else {

						this.lastWebhookUpdateCheck = {};
						this.theLoadingText = '';
						this.$snotify.error("It looks like we are having an issue, please refresh the page.", "Payment");

					}

				}

			}

		},

		closePayment (info) {

			this.showPaymentWindow = false;

			general.modalClose();

			if ( info.success ) {

				if ( this.straightToPayment ) {

					this.straightToPaymentLoading = true;
					this.theLoadingText = 'Completing your purchase...';

				}

				this.registerForUpdates ( ['invoice.payment_succeeded','invoice.paid'] );

			}

		},

		saveSettings () {


		},

		close() {

			this.$emit('close');

		},

	    getMore() {

	    	this.showPaymentWindow = true;

	    }

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.modal {

	.modal-inner {

		max-width: 550px;

		.completing-purchase {

			min-height: 100px;

		}

		.modal-title {

			background-color: @formDefaultColour;
			text-align: center;
			padding: 35px 20px 20px;

			em {

				font-style: normal;
				font-size: 2.5em;
				text-transform: uppercase;
				padding-bottom: 20px;
				display: inline-block;

			}

		}

		.modal-inner-scroll {

			p {

				font-size: 18px;
				max-width: 400px;
   				width: 65%;
				padding: 0 0 20px;
    			margin: 0;

				&.em, em {

					color: @formDefaultColour;
					font-style: normal;
					font-weight: @bold;
					font-size: 1.2em;

				}

				em {

					font-size: 1.35em;

				}

			}

			.btn-wrap {

				text-align: center;

				.large-button {

					position: relative;
					z-index: 2;

					&.get {

						font-weight: @bold;
						font-size: 18px;

					}

				}

			}

			.mag {

				background: url(./../../assets/img/magnifying-glass.svg) 0 0 no-repeat;
				background-size: 100% auto;
				width: 100px;
				height: 170px;
				display: block;
				position: absolute;
				right: 0;
				top: 125px;
				width: 35%;


			}

		}

	}

}

@media screen and (min-width: 768px) {

	.modal {

		.modal-inner {

			max-width: 650px;
			padding-bottom: 40px;
			min-height: 100px;

			.modal-title {

				margin-bottom: 36px;
				font-size: 24px;

			}

			.modal-inner-scroll {

				padding: 0 40px;

				p {

					width: 70%;
					font-size: 20px;
					max-width: 430px;

					&.em {

						font-size: 24px;

					}

					br {

						display: none;

					}

				}

				.btn-wrap {

					.large-button {

						&.get {
							
							font-size: 20px;

						}

					}

				}

				.mag {

					top: 110px;
					width: 34%;
					height: 200px;

				}

			}

		}

	}

}
</style>